if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();

        this.swatches = this.querySelectorAll('[data-product-swatch]')
        this.materialEl = this.querySelector('[data-product-card-material-el]')
        this.titleEl = this.querySelector('[data-product-card-title-el]')
        this.images = this.querySelectorAll('[data-product-card-image-id]')
        this.originalPriceEl = this.querySelector('[data-product-card-main-price-el]')
        this.discountPriceEl = this.querySelector('[data-product-card-sale-price-el]')
        this.urlEls = this.querySelectorAll('[data-product-card-url-el]')
        this.activeSwatch = null
        this.activeImages = null

        if (typeof this.swatches === 'undefined') { return }

        this.initProductCard()
      }

      initProductCard () {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => {
            const bundleId = swatch.dataset.productSwatchId + ''

            // Update ATC variant ID
            this.swatches.forEach((swatch) => {
              swatch.classList.toggle('active-swatch', swatch.dataset.productSwatchId === bundleId)
              this.activeSwatch = swatch.dataset.productSwatchId === bundleId
                ? swatch
                : this.activeSwatch
            })

            this.activeImages = [...this.images].filter((image) => image.getAttribute('data-product-card-image-id') === bundleId)

            this.activeImages.forEach((image) => {
              if (image.classList.contains('hide')) {
                image.classList.remove('hide')
              }
            })

            const noActiveImageArr = [...this.images].filter((image) => !this.activeImages.includes(image)).forEach((image) => image.classList.add('hide'))

            this.titleEl.textContent = this.activeSwatch.getAttribute('data-product-card-title')
            this.materialEl.textContent = this.activeSwatch.getAttribute('data-product-card-material')

            this.urlEls.forEach((url) => {
              url.setAttribute('href', this.activeSwatch.getAttribute('data-product-card-url'))
            })

            this.handlePriceFormatting()
          })
        })
      }

      handlePriceFormatting () {
        if (typeof this.originalPriceEl === 'undefined') { return }

        const original_price = this.activeSwatch.getAttribute('data-product-card-price')
        const discount_price = this.activeSwatch.getAttribute('data-product-card-compare-price')

        this.discountPriceEl.textContent = discount_price || ''
        this.originalPriceEl.textContent = original_price
      }
    }
  );
}

